import { render, staticRenderFns } from "./CotacaoFreteDetalhesCardHeader.vue?vue&type=template&id=2eca1803"
import script from "./CotacaoFreteDetalhesCardHeader.vue?vue&type=script&lang=js"
export * from "./CotacaoFreteDetalhesCardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports